import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=a96ee83c&scoped=true&"
import script from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
export * from "./InvoiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=a96ee83c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ee83c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GCardIcon from 'shared/global/components/CardIcon.vue'
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {GCardIcon,VCard,VCardTitle,VDataTable,VDivider})
